import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-menu-for-calc',
  templateUrl: './menu-for-calc.component.html',
  styleUrls: ['./menu-for-calc.component.css']
})
export class MenuForCalcComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  backToMain() {
    this.router.navigate(['/']).then(result=>{window.location.href = 'https://hsc.gov.ua';});
  }

}
